import { useAppSelector } from '../../../../store/hooks';
import _ from 'underscore';

export type NonStringDataObj = {
    type: 'Variable';
    value: string;
} | {
    type: 'Link';
    title: string;
    href: string;
} | {
    type: 'Newline';
} | {
    type: 'Style';
    style: 'bold' | 'italic' | 'underlined' | 'strikethrough' | 'red' | 'green' | 'primary-color';
    text: string;
};

export type ParseResult = (string|NonStringDataObj)[];

export function parseRefText(text: string = ''): ParseResult {
    const userVariables = useAppSelector(state => state.globalState.user?.variables || {});

    const reAddress = /\{\{ *var +([a-zA-Z0-9_]+) *\}\}/gm;
    let varMatch: RegExpExecArray | null;
    let textArr = text.split('\n');
    let indexFrom = 0, indexTo = 0;

    // parse variables and add in newline objects
    let resultArr: ParseResult = _.reduce(
        textArr,
        (acc: ParseResult, textPart: string, i: number) => {
            indexFrom = 0;
            indexTo = 0;
            while ((varMatch = reAddress.exec(textPart)) !== null) {
                let varName = varMatch[1];
                indexTo = reAddress.lastIndex - varMatch[0].length;
                acc.push(textPart.substring(indexFrom, indexTo));
                indexFrom = reAddress.lastIndex;
                acc.push({type: 'Variable', value: userVariables[varName] || ''});
            }
            acc.push(textPart.substring(indexFrom));
            if (i < textArr.length - 1) {
                acc.push({type: 'Newline'});
            }
            return acc;
        },
        []
    );

    // parse links
    let link: RegExpExecArray | null;
    const reLink = /\{\{ *link +([^ ]+?) +([^ ]+?) *\}\}/gm;
    resultArr = _.reduce(
        resultArr,
        (acc: ParseResult, item: string|NonStringDataObj) => {
            if (typeof(item) === 'string') {
                indexFrom = 0;
                indexTo = 0;
                while ((link = reLink.exec(item)) !== null) {
                    indexTo = reLink.lastIndex - link[0].length;
                    acc.push(item.substring(indexFrom, indexTo));
                    acc.push({type: 'Link', title: link[2], href: link[1]});
                    indexFrom = reLink.lastIndex;
                }
                acc.push(item.substring(indexFrom));
            } else {
                acc.push(item);
            }
            return acc;
        },
        []
    );

    // parse styles
    let style: RegExpExecArray | null;
    const resultStyle = /\{\{ *style +([^ ]+?) +<(.+?)> *\}\}/gm;
    resultArr = _.reduce(
        resultArr,
        (acc: ParseResult, item: string|NonStringDataObj) => {
            if (typeof(item) === 'string') {
                indexFrom = 0;
                indexTo = 0;
                while ((style = resultStyle.exec(item)) !== null) {
                    indexTo = resultStyle.lastIndex - style[0].length;
                    acc.push(item.substring(indexFrom, indexTo));
                    acc.push({type: 'Style', style: style[1] as any, text: style[2]});
                    indexFrom = resultStyle.lastIndex;
                }
                acc.push(item.substring(indexFrom));
            } else {
                acc.push(item);
            }
            return acc;
        },
        []
    );

    return resultArr;
}